import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface crmTaskStore {
  conversationId?: string;
  setConversationId: (value: string) => void;
  assignedToName: {
    [conversationId: string]: string;
  };
  getAssignedToName: () => string | undefined;
  getAssignedToContactName: () => string | undefined;
  setAssignedToName: (value: string) => void;

  assignedToContactName: {
    [conversationId: string]: string;
  };
  setAssignedToContactName: (value: string) => void;

  assignedToTaskUserName: {
    [crmUserId: string]: string;
  };
  setAssignedToTaskUserName: (crmUserId: string, value: string) => void;

  clearCrmTasks: () => void;
}

export const useCrmTaskStore = create(
  persist<crmTaskStore>(
    (set, getState) => ({
      conversationId: "",
      setConversationId: (value: string) => {
        set({ conversationId: value });
      },
      assignedToName: {},
      getAssignedToName: () => {
        const conversationId = getState().conversationId;
        if (!conversationId) return;
        return getState().assignedToName[conversationId];
      },
      setAssignedToName: (value: string) => {
        const conversationId = getState().conversationId;
        if (!conversationId) return;
        set({
          assignedToName: {
            ...getState().assignedToName,
            [conversationId]: value,
          },
        });
      },

      assignedToContactName: {},
      getAssignedToContactName: () => {
        const conversationId = getState().conversationId;
        if (!conversationId) return;
        return getState().assignedToContactName[conversationId];
      },
      setAssignedToContactName: (value: string) => {
        const conversationId = getState().conversationId;
        if (!conversationId) return;
        set({
          assignedToContactName: {
            ...getState().assignedToContactName,
            [conversationId]: value,
          },
        });
      },

      assignedToTaskUserName: {},
      setAssignedToTaskUserName: (taskId: string, value: string) => {
        set({
          assignedToTaskUserName: {
            ...getState().assignedToTaskUserName,
            [taskId]: value,
          },
        });
      },

      clearCrmTasks: () => {
        set({
          conversationId: "",
          assignedToName: {},
          assignedToContactName: {},
          assignedToTaskUserName: {},
        });
      },
    }),
    {
      name: "crmTaskStore",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
